module.exports = __webpack_public_path__ + "static/media/providerGoldTop3M.d40742a3.webp";